/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Extracted_Text_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading extracted text..." |
*
* @param {Spaces_Extracted_Text_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_extracted_text_loading = /** @type {((inputs?: Spaces_Extracted_Text_LoadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Extracted_Text_LoadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Extrahierter Text wird geladen...")
	return /** @type {LocalizedString} */ ("Loading extracted text...")
});